import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Salesperson } from '@galaxy/types';

export interface SalespersonMultiSelectConfig {
  allSalespeople$: Observable<Salesperson[]>;
  salespersonId$: Observable<string>;
  salespersonName$: Observable<string>;
  initWithLoggedInSalesperson: boolean;
}

export const SALESPERSON_MULTI_SELECT_CONFIG_TOKEN = new InjectionToken<SalespersonMultiSelectConfig>(
  'general dependency data for the salesperson multi select filter',
);
export const ALL_SALESPEOPLE_TOKEN: InjectionToken<Observable<Salesperson[]>> = new InjectionToken(
  'token for all salespeople',
);
export const SALESPERSON_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  'token for current salesperson ID',
);
export const SALESPERSON_NAME_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  'token for current salesperson name',
);
export const INIT_WITH_CUR_SALESPERSON_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  'token for if the filter should initialize with a filter for the current salesperson',
);
